var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrolleybus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.9,17.3c0,0.1,0.1,0.1,0.1,0.1h1.3c0,0,0.1,0,0.1-0.1L7.9,16H5.5L5.9,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.4,16.1c0.4,0,0.6,0.3,0.6,0.7c0,0.4-0.3,0.7-0.6,0.7c-0.4,0-0.6-0.3-0.6-0.7C4.8,16.4,5,16,5.4,16.1z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4,16.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C5,16.5,5.2,16.4,5.4,16.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M8.1,16.1c0.4,0,0.6,0.3,0.6,0.7c0,0.4-0.3,0.7-0.6,0.7c-0.4,0-0.6-0.3-0.6-0.7C7.5,16.4,7.7,16,8.1,16.1z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1,16.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.1,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C7.7,16.5,7.9,16.4,8.1,16.4z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.4,16.7C5.4,16.7,5.5,16.8,5.4,16.7c0.1,0.1,0,0.2,0,0.2C5.4,16.9,5.3,16.8,5.4,16.7 C5.3,16.8,5.4,16.7,5.4,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M8.1,16.7C8.1,16.7,8.2,16.8,8.1,16.7c0.1,0.1,0,0.2,0,0.2C8,16.9,8,16.8,8.1,16.7C8,16.8,8,16.7,8.1,16.7z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,16.9C6.1,16.9,6.1,16.9,6.1,16.9l1.2,0c0,0,0,0,0,0l0,0l0,0L6.1,16.9C6.1,17,6.1,17,6.1,16.9L6.1,16.9z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,16.7C6.1,16.6,6.1,16.6,6.1,16.7l1.2,0c0,0,0,0,0,0l0,0l0,0L6.1,16.7C6.1,16.7,6.1,16.7,6.1,16.7 L6.1,16.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,16.4C6.1,16.4,6.1,16.4,6.1,16.4l1.2,0c0,0,0,0,0,0l0,0l0,0L6.1,16.4C6.1,16.4,6.1,16.4,6.1,16.4 L6.1,16.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,17.2C6.1,17.1,6.1,17.1,6.1,17.2l1.2,0c0,0,0,0,0,0l0,0l0,0L6.1,17.2C6.1,17.2,6.1,17.2,6.1,17.2 L6.1,17.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.4,17.3c0,0.1,0.1,0.1,0.1,0.1h1.3c0,0,0.1,0,0.1-0.1l0.4-1.3H16L16.4,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.9,16.1c0.4,0,0.6,0.3,0.6,0.7c0,0.4-0.3,0.7-0.6,0.7s-0.6-0.3-0.6-0.7C15.3,16.4,15.5,16,15.9,16.1z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9,16.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4 C15.5,16.5,15.7,16.4,15.9,16.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.6,16.1c0.4,0,0.6,0.3,0.6,0.7c0,0.4-0.3,0.7-0.6,0.7c-0.4,0-0.6-0.3-0.6-0.7C17.9,16.4,18.2,16,18.6,16.1 z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6,16.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.1,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4 C18.2,16.5,18.3,16.4,18.6,16.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.9,16.7C15.9,16.7,16,16.8,15.9,16.7c0.1,0.1,0,0.2,0,0.2C15.8,16.9,15.8,16.8,15.9,16.7 C15.8,16.8,15.8,16.7,15.9,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.5,16.7C18.6,16.7,18.6,16.8,18.5,16.7c0.1,0.1,0.1,0.2,0,0.2C18.5,16.9,18.5,16.8,18.5,16.7 C18.5,16.8,18.5,16.7,18.5,16.7z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,16.9C16.6,16.9,16.6,16.9,16.6,16.9l1.2,0c0,0,0,0,0,0l0,0l0,0L16.6,16.9C16.6,17,16.6,17,16.6,16.9 L16.6,16.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,16.7C16.6,16.6,16.6,16.6,16.6,16.7l1.2,0c0,0,0,0,0,0l0,0l0,0L16.6,16.7 C16.6,16.7,16.6,16.7,16.6,16.7L16.6,16.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,16.4C16.6,16.4,16.6,16.4,16.6,16.4l1.2,0c0,0,0,0,0,0l0,0l0,0L16.6,16.4 C16.6,16.4,16.6,16.4,16.6,16.4L16.6,16.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,17.2C16.6,17.1,16.6,17.1,16.6,17.2l1.2,0c0,0,0,0,0,0l0,0l0,0L16.6,17.2 C16.6,17.2,16.6,17.2,16.6,17.2L16.6,17.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1,13.5 1,13.4 1,13.4 1.5,11.5 1.5,11.5 1.5,11.5 1.5,11.3 22.5,11.3 22.5,11.5 22.5,11.5  22.5,11.5 23,13.4 23,13.4 23,13.5 23,13.5 1,13.5  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,13.5l-0.5,2.4c0,0,0,0-0.1,0H1.6c0,0-0.1,0-0.1,0L1,13.8l0-0.2H23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,15.9C1.5,15.9,1.5,15.9,1.5,15.9l20.9,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1v0.4c0,0.3-0.2,0.5-0.5,0.5h-2.8 v0L19,16.4c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.2h-2.9c-0.1,0-0.3,0.1-0.3,0.2c0,0,0,0,0,0l-0.1,0.4v0H8.7v0l-0.1-0.4l0,0 c-0.1-0.1-0.2-0.2-0.3-0.2H5.3c-0.1,0-0.3,0.1-0.3,0.2c0,0,0,0,0,0l-0.2,0.4v0H2c-0.3,0-0.5-0.2-0.5-0.5L1.5,15.9 C1.5,16,1.5,16,1.5,15.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.8,8.4l2.4-1.9l2.4,1.9l-2.4,1.9L14.8,8.4z M17.1,6.9l-1.9,1.5l1.9,1.5L19,8.4L17.1,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.2,10.4v-0.1c0-0.1,0.1-0.2,0.2-0.2h1.5c0.1,0,0.2,0.1,0.2,0.2v0.1c0,0.1-0.1,0.2-0.2,0.2h-1.5 C16.3,10.6,16.2,10.5,16.2,10.4z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9,10.3h20.2c0.3,0,0.5,0.2,0.5,0.5v0.4c0,0,0,0.1-0.1,0.1h-21c0,0-0.1,0-0.1-0.1v-0.4 C1.4,10.5,1.6,10.3,1.9,10.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.4,13.1v-1.3c0-0.2,0.1-0.3,0.3-0.3h1.5c0.1,0,0.3,0.1,0.3,0.3v1.3c0,0.2-0.1,0.3-0.3,0.3h-1.5 C16.5,13.4,16.4,13.3,16.4,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M13.6,13.1v-1.3c0-0.2,0.1-0.3,0.3-0.3h1.5c0.1,0,0.3,0.1,0.3,0.3v1.3c0,0.2-0.1,0.3-0.3,0.3h-1.5 C13.7,13.4,13.6,13.3,13.6,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M10.8,13.1v-1.3c0-0.2,0.1-0.3,0.3-0.3h1.5c0.1,0,0.3,0.1,0.3,0.3v1.3c0,0.2-0.1,0.3-0.3,0.3h-1.5 C10.9,13.4,10.8,13.3,10.8,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M8.2,13.1v-1.3c0-0.2,0.1-0.3,0.3-0.3H10c0.1,0,0.3,0.1,0.3,0.3v1.3c0,0.2-0.1,0.3-0.3,0.3H8.5 C8.3,13.4,8.2,13.3,8.2,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.6,13.1v-1.3c0-0.2,0.1-0.3,0.3-0.3h1.5c0.1,0,0.3,0.1,0.3,0.3v1.3c0,0.2-0.1,0.3-0.3,0.3H5.9 C5.8,13.4,5.6,13.3,5.6,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21.6,11.9v1.3c0,0.2,0.1,0.3,0.3,0.3H23v0l-0.4-1.8v0h-0.7C21.7,11.5,21.6,11.6,21.6,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2.1,11.4H1.5v0L1,13.3v0h1.1c0.1,0,0.3-0.1,0.3-0.3v-1.3C2.4,11.6,2.3,11.5,2.1,11.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.1,16.3v-3.6c0-0.2,0.1-0.3,0.3-0.3h1.2c0.2,0,0.3,0.1,0.3,0.3v3.6c0,0.2-0.1,0.3-0.3,0.3h-1.2 C19.3,16.6,19.1,16.5,19.1,16.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3,16.3v-3.6c0-0.2,0.1-0.3,0.3-0.3h1.2c0.2,0,0.3,0.1,0.3,0.3v3.6c0,0.2-0.1,0.3-0.3,0.3H3.3 C3.1,16.6,2.9,16.5,3,16.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21.8,15.7L21.8,15.7c0-0.1,0-0.2,0.1-0.2h0.7c0,0,0.1,0,0.1,0.1v0c0,0.1,0,0.1-0.1,0.1L21.8,15.7 C21.8,15.8,21.8,15.7,21.8,15.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 16.2,
    style: {
      fill: "#000"
    },
    width: 0.3,
    height: 0.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 9.8,
    style: {
      fill: "#000"
    },
    width: 0.5,
    height: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.2,14.9l0,0.3c0,0-0.1-0.1-0.1-0.2C1.1,15,1.2,15,1.2,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2,15v0.1c0,0,0,0.1,0,0.1l-0.6,0.1c0,0,0,0-0.1,0l0,0l0,0l0-0.4l0,0l0,0l0,0c0,0,0,0,0.1,0L2,15 C2,14.9,2.1,15,2,15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.3,15.3L1.3,15.3L1.3,15.3L1.3,15.3L1.2,15v0h0l0,0l0,0l0,0L1.3,15.3L1.3,15.3L1.3,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.3,15.7L1.3,15.7c0-0.1,0-0.2,0.1-0.2h0.7c0,0,0.1,0.1,0.1,0.1v0c0,0.1,0,0.1-0.1,0.1H1.4 C1.3,15.8,1.3,15.7,1.3,15.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 16.2,
    style: {
      fill: "#000"
    },
    width: 0.3,
    height: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolleybus);
export default __webpack_public_path__ + "static/media/trolleybus.35a61a8dbba781366c9607e4f126ac17.svg";
export { ForwardRef as ReactComponent };